export const SESSION_KEY = "sp.session.v1";

const ROLES = ["parent", "student", "tutor", "teacher", "admin"];

export function sessionFromAccount(data, token = "", fallbackEmail = "") {
  const role = ROLES.includes(data.role) ? data.role : "parent";
  return {
    token: data.token || token || "",
    id: data.id || "",
    name: data.name || "",
    email: data.email || fallbackEmail,
    role,
    familyId: data.familyId || "",
    parentName: data.parentName || "Parent",
    studentName: data.studentName || "Élève",
    studentId: data.studentId || "",
    tutorName: data.tutorName || "",
    forfait: Number(data.forfait) || 1,
    integrator: Boolean(data.integrator),
    onboarded: Boolean(data.onboarded),
  };
}

export function loadSession() {
  try {
    const saved = JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
    if (saved && saved.email) return saved;
  } catch {
    /* ignore a broken session */
  }
  return null;
}

export const ADMIN_KEY = "sp.admin.v1";

export function saveSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  if ((session?.role === "admin" || session?.integrator) && session.token) localStorage.setItem(ADMIN_KEY, session.token);
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}

export const SESSION_EXPIRED_EVENT = "sp:session-expired";

/** Authenticated call. A 401 closes the local session everywhere. */
export async function apiFetch(path, token, options = {}) {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const headers = { ...(options.headers || {}) };
  if (token) headers["X-Account-Token"] = token;
  if (options.body && !headers["Content-Type"]) headers["Content-Type"] = "application/json";
  const response = await fetch(`${base}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (response.status === 401 && token && !options.keepSession) {
    clearSession();
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
  }
  if (!response.ok) {
    const error = new Error(data.detail || "Action impossible.");
    error.status = response.status;
    error.detail = data.detail;
    throw error;
  }
  return data;
}
